export default {"src":"/_next/static/media/like.4394f99c.svg","height":11,"width":13,"blurWidth":0,"blurHeight":0};